import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const HomeIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 14"
  >
    <path d="M12.773 13.5H3.227a.7.7 0 0 1-.482-.194.65.65 0 0 1-.2-.468V6.884H.5L7.541.672a.694.694 0 0 1 .918 0L15.5 6.884h-2.046v5.954a.65.65 0 0 1-.2.468.7.7 0 0 1-.481.194m-4.091-1.323h3.409V5.664L8 2.056 3.91 5.664v6.513h3.408v-3.97h1.364z" />
  </svg>
);
HomeIcon.id = 'HomeIcon';
HomeIcon.displayName = 'HomeIcon';
export default HomeIcon;
